import { render, staticRenderFns } from "./CustomerDetail-customerAttachments.vue?vue&type=template&id=bedcbfe0&scoped=true"
import script from "./CustomerDetail-customerAttachments.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-customerAttachments.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail-customerAttachments.vue?vue&type=style&index=0&id=bedcbfe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedcbfe0",
  null
  
)

export default component.exports